import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=87c0c10c&scoped=true&"
import script from "./ClientsTable.vue?vue&type=script&lang=js&"
export * from "./ClientsTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientsTable.vue?vue&type=style&index=0&id=87c0c10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c0c10c",
  null
  
)

export default component.exports